import React, {Component} from 'react';

class OverviewTab1 extends Component {

    render() {
        return (<div>OverviewTab1</div>)
    }
}

export default OverviewTab1;